import React, { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import 'moment/locale/eu';
import 'moment/locale/es';
import 'moment/locale/de';
import 'moment/locale/ca';
import 'moment/locale/gl';
import { isMobile } from 'react-device-detect';
import i18n from 'i18next';
import { ReactComponent as CloseSvg } from '../assets/svg/close.svg';
import rotatedLogo from '../assets/images/logo-rotado.png';
import SessionService from '../services/SessionService';
import { useAppStore } from '../store/AppContext';
import { PopUpService } from '../services';
import { PopUpDto } from '../types/Types';

const appEroskiEsUrl = 'https://www.eroski.es/apps-eroski/';
const appEroskiEuUrl = 'https://www.eroski.es/eu/eroski-appak/';
const appEroskiEsMovilUrl = 'https://eroski.onelink.me/pF7u/e5d37d';
const appEroskiEuMovilUrl = 'https://eroski.onelink.me/pF7u/y0ipevak';

interface Props {
  page: string;
}

const DownloadAppPopup: FC<Props> = (props) => {
  const { page } = props;
  const [showPopup, setShowPopup] = useState<boolean>(false);
  const [isCheckAppSession, setIsCheckAppSession] = useState<boolean>(false);
  const [textTitulo, setTextTitulo] = useState<string>('');
  const [textMensaje, setTextMensaje] = useState<any>('');
  const [textBoton, setTextBoton] = useState<string>('');
  const [tooltipTextBoton, setTooltipTextBoton] = useState<string>('');
  const { t } = useTranslation();
  const dataApp = useAppStore();
  const idioma = dataApp.lang;
  function escogeURL(): void {
    if (isMobile) {
      switch (idioma) {
        case 'es':
          window.open(appEroskiEsMovilUrl, '_blank');
          break;
        case 'eu':
          window.open(appEroskiEuMovilUrl, '_blank');
          break;
        default:
          window.open(appEroskiEsUrl, '_blank');
      }
    } else {
      switch (idioma) {
        case 'es':
          window.open(appEroskiEsUrl, '_blank');
          break;
        case 'eu':
          window.open(appEroskiEuUrl, '_blank');
          break;
        default:
          window.open(appEroskiEsUrl, '_blank');
      }
    }
  }

  function escogeMensaje() {
    let mesajePopup: string;
    switch (page) {
      case 'vales':
        mesajePopup = t('popup-descarga-app.message-vales-temporal');
        break;
      case 'saldo':
        mesajePopup = t('popup-descarga-app.message-saldo');
        break;
      case 'ahorros':
        mesajePopup = t('popup-descarga-app.message-ahorro');
        break;
      default:
        mesajePopup = t('popup-descarga-app.message-ahorro');
    }
    return mesajePopup;
  }

  function setTextos(respuesta: PopUpDto | undefined) {
    setTextTitulo(
      respuesta?.tituloTxt ?? t('popup-descarga-app.title-temporal'),
    );
    let mensajeHtml: JSX.Element[] = [];
    const mensaje: string = respuesta?.cuerpoTxt ?? escogeMensaje();
    if (mensaje.includes('\r\n')) {
      const lineas = mensaje.split('\r\n');
      mensajeHtml = lineas.map((parrafo, indice) => (
        <p key={`pBodyBanner-${indice + 1}`}>{parrafo}</p>
      ));
    } else {
      mensajeHtml.push(<p key="pBodyBanner-1">{mensaje}</p>);
    }
    setTextMensaje(mensajeHtml);
    setTextBoton(respuesta?.botonTxt ?? t('popup-descarga-app.button'));
    setTooltipTextBoton(
      respuesta?.botonTxtTooltip ?? t('popup-descarga-app.title-temporal'),
    );
  }

  const setTxtShowPopUp = async () => {
    const respuesta: PopUpDto = await PopUpService.getTxtPopUp({
      nombreWebView: page,
    })
      .then((response) => {
        const { data } = response;
        return data;
      })
      .catch((e) => {
        console.log(e);
      });
    setTextos(respuesta);
    setShowPopup(true);
  };

  useEffect(() => {
    if (isCheckAppSession) {
      setTxtShowPopUp();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n.language]);

  useEffect(() => {
    SessionService.checkAppSession()
      .then((response) => {
        if (
          response.data.error === false &&
          response.data.pojo.appDescargada === false
        ) {
          setIsCheckAppSession(true);
          setTxtShowPopUp();
        }
      })
      .catch((e) => {
        console.log(e);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {showPopup && (
        <div className="popup-descargar-app">
          <div className="popup-descargar-app__logo-wrapper">
            <img src={rotatedLogo} alt="Logo de eroski" />
          </div>
          <div>
            <p className="popup-descargar-app__title">{textTitulo}</p>
            {textMensaje}
            <button
              title={tooltipTextBoton}
              className="popup-descargar-app__button"
              type="button"
              onClick={() => escogeURL()}
            >
              {textBoton}
            </button>
          </div>
          <CloseSvg
            title="Cerrar popup de descarga"
            onClick={() => setShowPopup(false)}
            className="close-svg-banner"
          />
        </div>
      )}
    </>
  );
};

export default DownloadAppPopup;
